import { useState, useRef, useEffect, useCallback } from 'react';
import { useChats } from './useChats';
import { useResponsiveLayout } from './useResponsiveLayout';
import { useAppStore } from '../../../../store';
import { selectCurrentUserRecord } from '../../../../store/common/userRecord/slice';

export const useDashboard = () => {

    const userRecord = useAppStore(selectCurrentUserRecord);
  
  const { isMobile } = useResponsiveLayout();
  const toast = useRef(null);
  
  const [state, setState] = useState({
    selectedChat: null,
    activeChat: null,
    isLoading: true
  });

  const {
    guestChats,
    unreadMessages,
    markChatAsRead,
    turnOffBuzz,
    isLoading: isChatsLoading
  } = useChats(userRecord);

  const handleBackToChatList = useCallback(() => {
    setState(prev => ({
      ...prev,
      selectedChat: null,
      activeChat: null
    }));
  }, []);

  const handleChatSelect = useCallback((chatId) => {
    setState(prev => ({
      ...prev,
      selectedChat: chatId,
      activeChat: chatId
    }));
  }, []);

  // Handle unread messages and buzz
  useEffect(() => {
    if (state.activeChat && unreadMessages[state.activeChat]?.hasUnread) {
      markChatAsRead(state.activeChat);
    }
  }, [state.activeChat, unreadMessages, markChatAsRead]);

  useEffect(() => {
    if (state.activeChat && unreadMessages[state.activeChat]?.buzzed) {
      turnOffBuzz(state.activeChat);
    }
  }, [state.activeChat, unreadMessages, turnOffBuzz]);

  
  // Only set local isLoading state, no global loader
  useEffect(() => {
    const isLoading = isChatsLoading || !guestChats;
    setState(prev => ({
      ...prev,
      isLoading
    }));
  }, [isChatsLoading, guestChats]);

  return {
    userRecord,
    isMobile,
    selectedChat: state.selectedChat,
    activeChat: state.activeChat,
    toast,
    guestChats,
    unreadMessages,
    markChatAsRead,
    handleBackToChatList,
    handleChatSelect,
    isLoading: state.isLoading
  };
}; 